import React, { useRef } from "react";
import { TouchableOpacity } from "react-native";
import GlobalMultiSelectPickerV2 from "./GlobalMultiSelectPickerV2";
import NSText from "./NSText";
import { AntDesign } from "@expo/vector-icons";
import ClearFilter from "./ClearFilter";

const MultiSelectDropDownFilterV2 = ({
  dropDownWidth,
  defaultTitle,
  setMiscModal,
  data,
  selectedIndices,
  selectedItem,
  canClearFilter,
  shouldNotAllowClearFilter,
  onItemPress,
  onClearFilter,
  hasSearch,
}: {
  dropDownWidth?: number;
  defaultTitle?: string;
  setMiscModal: any;
  data: { id: string; title: string }[];
  selectedIndices: number[];
  selectedItem: string;
  canClearFilter: boolean;
  shouldNotAllowClearFilter?: boolean;
  onItemPress: (value: any, index: number) => void;
  onClearFilter: () => void;
  hasSearch?: boolean;
}) => {
  const ref = useRef<TouchableOpacity>();
  return (
    <TouchableOpacity
      style={{
        flexDirection: "row",
        maxWidth: dropDownWidth || 200,
        paddingVertical: 8,
        paddingHorizontal: 15,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: canClearFilter ? "#6300A31A" : "#6300A333",
        backgroundColor: canClearFilter ? "#6300A31A" : "",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      ref={ref}
      onPress={() => {
        ref.current.measure((_, _1, width, height, pageX, pageY) => {
          setMiscModal(true, { x: pageX, y: pageY + height }, () => (
            <GlobalMultiSelectPickerV2
              width={dropDownWidth ?? width}
              coords={{ x: pageX, y: pageY + height }}
              data={data}
              hasSearch={hasSearch}
              selectedIndices={selectedIndices}
              onItemPress={(value, index) => {
                onItemPress?.(value, index);
                setMiscModal(false, { x: -1, y: -1 }, null);
              }}
            />
          ));
        });
      }}
    >
      <NSText
        style={{
          flexShrink: 1,
          maxWidth: "90%",
          marginEnd: 10,
          fontSize: 14,
          color: "#303030",
        }}
        props={{ numberOfLines: 1 }}
        text={!!selectedItem ? selectedItem : defaultTitle}
      />
      <AntDesign name="caret-down" size={10} color="#6300A3" />
      {canClearFilter && !shouldNotAllowClearFilter ? <ClearFilter onClearFilter={onClearFilter} /> : null}
    </TouchableOpacity>
  );
};

export default MultiSelectDropDownFilterV2;
